export default __webpack_public_path__ + "staticlp1/media/selecoes.17c903a0.jpg";